import { render, staticRenderFns } from "./msCheckbox.vue?vue&type=template&id=a55520de&scoped=true"
import script from "./msCheckbox.vue?vue&type=script&lang=js"
export * from "./msCheckbox.vue?vue&type=script&lang=js"
import style0 from "./msCheckbox.vue?vue&type=style&index=0&id=a55520de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55520de",
  null
  
)

export default component.exports